


















import { Session } from '../../utils/Session';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { InputPages } from '../../components/organisms/InputPages';

@Component({ components: {} })
export default class StudentPaymentPage extends InputPages {
  get user_id() {
    return Session.getSessionUserId();
  }
  get has_user_id() {
    return this.user_id && this.user_id.length > 0;
  }
  get building() {
    return Session.getSessionBuildingId();
  }

  get alijPath() {
    if (location.host === 'circle-o.jp') {
      return 'https://payment.alij.ne.jp/service/credit';
    } else {
      return 'https://test-payment.alij.ne.jp/service/credit';
    }
  }
}
